export default __webpack_public_path__ + "static/media/property_1_11.58a5b766.webp";